import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';


import { TipoMedicionBO } from '../Models/TipoMedicionBO';
import { TipoMedicionMobile } from '../Models/TipoMedicionMobile';
@Injectable()
export class MedicionService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService

  ) { }


  public GuardarRegistro(medicion: TipoMedicionBO): Observable<any> {

    try {

      let params = JSON.stringify(medicion);

      let url = this._utiles.getURL("Medicion/");

      let headers = new Headers({ 'Content-Type': 'application/json' });

      let data: any;


      return this._http.post(url, medicion, { headers: headers }).map(res => res.json());


    } catch (error) {
      console.log(error);
    }


  }
  ObtenerMediciones(compania: string): Observable<TipoMedicionBO[]> {

    try {

      let url = this._utiles.getURL("Medicion/" + compania );

      return this._http.get(url).map((response: Response) => {
        return <TipoMedicionBO[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


  ObtenerMedicion(compania: string,idMedicion:string): Observable<TipoMedicionBO> {

    try {

      let url = this._utiles.getURL("Medicion/" + compania +"/"+ idMedicion);

      return this._http.get(url).map((response: Response) => {
        return <TipoMedicionBO>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

  ObtenerReporteMedicionesVehiculo(compania: string, idVehiculo: string ,fechaInicio: Date, fechaFin: Date): Observable<TipoMedicionMobile[]> {

    try {

      let url = this._utiles.getURL("Medicion/reporteMedicionVehiculo/" + compania +"/"+ idVehiculo +"/"+ fechaInicio+"/"+ fechaFin);

      return this._http.get(url).map((response: Response) => {
        return <TipoMedicionMobile[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

}
